import { createApp, nextTick } from 'vue';
import sanitizeHTML from 'sanitize-html';

import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper';

import NodeToolbox from '@v/NodeToolbox.vue';
import ShareModal from '@v/ShareModal.vue';
import MarkingModal from '@v/MarkingModal.vue';

import base64 from '@js/modules/utils/base64';
import utils from '@js/modules/utils/utils';
import { showShareModal, showMarkingModal } from '@js/modules/parts/share';

const app = createApp({
    data: () => {
        return {
            node: null,
            image_info: null,
            image_text: '',
        };
    },
    components: {
        NodeToolbox,
        MarkingModal,
        ShareModal,
        Swiper,
        SwiperSlide,
    },
    methods: {
        showShareModal,
        showMarkingModal,
        sanitize(str) {
            return utils.nl2br(sanitizeHTML(str));
        },
        setImageText() {
            const slideEl = document.querySelector('#mainSlider .swiper-slide-active');
            if (slideEl) {
                const text = slideEl.getAttribute('data-text');
                if (text) {
                    this.image_text = utils.nl2br(sanitizeHTML(text));
                }
            }
        },
        afterInit(event) {
            this.setImageText();
        },
        slideChangeStart(swiper) {
            this.image_text = '';
        },
        slideChangeEnd(swiper) {
            this.setImageText();
        },
    },
    setup() {
        return {
            modules: [Navigation, Pagination],
        };
    },
    mounted() {
        const node = (<HTMLInputElement>document.getElementById('node')).value;
        if (node) {
            base64.decode(node, 'UTF-8').then(res => {
                this.node = JSON.parse(res);

                var image_info = [];
                if (this.node.image_info && this.node.image_info.length > 0) {
                    this.node.image_info.forEach(info => {
                        if (info.item_image !== '') {
                            image_info.push(info);
                        }
                    });
                }
                this.image_info = image_info;
            });
        }
    },
});
app.mount('#app');
